module.exports = __webpack_public_path__ + "5c6fa3c9023a76d7ddd13c2e52438ef4.jpg";